module.exports = __webpack_public_path__ + "media/images/stickers/sticker3-98b22b3aa8ecd60c8d35588765a93892.svg";